module.exports = __webpack_public_path__ + "static/media/footer-image2.e36a21fe.png";